import React from "react";
import { ThumbsUp, MessageCircle, Eye } from "lucide-react";
import { ViewersList } from "./ViewersList";

export function ThreadActions({
  likes,
  isLiked,
  commentsCount,
  showCommentEditor,
  views,
  onLike,
  onComment,
  backendUrl,
  profilePicture,
}) {
  const [showViewers, setShowViewers] = React.useState(false);
  const [, setShowLikes] = React.useState(false);
  return (
    <div className="flex items-center gap-6">
      <div className="relative">
        <button
          onClick={onLike}
          onMouseEnter={() => setShowLikes(true)}
          onMouseLeave={() => setShowLikes(false)}
          className={`flex items-center gap-1.5 ${
            isLiked ? "text-blue-500" : "text-gray-400"
          } hover:text-blue-600 transition-colors`}
        >
          <ThumbsUp
            size={16}
            className={isLiked ? "fill-current" : ""}
            strokeWidth={2}
          />
          <span className="text-sm font-semibold">
            {Array.isArray(likes) ? likes.length : 0}
          </span>
        </button>
        {/* <LikesList
          show={showLikes}
          users={likes}
          backendUrl={backendUrl}
          profilePicture={profilePicture}
          avatar={avatar}
        /> */}
      </div>
      <button
        onClick={onComment}
        className={`flex items-center gap-1.5 ${
          showCommentEditor ? "text-blue-500" : "text-gray-400"
        } hover:text-blue-600 transition-colors`}
      >
        <MessageCircle size={16} strokeWidth={2} />
        <span className="text-sm font-semibold">{commentsCount}</span>
      </button>
      <div className="relative">
        <button
          className="flex items-center gap-1.5 text-gray-400 hover:text-gray-600 transition-colors"
          onMouseEnter={() => setShowViewers(true)}
          onMouseLeave={() => setShowViewers(false)}
        >
          <Eye size={16} strokeWidth={2} />
          <span className="text-sm font-semibold">{views.length}</span>
        </button>
        <ViewersList
          show={showViewers}
          viewers={views}
          backendUrl={backendUrl}
          profilePicture={profilePicture}
        />
      </div>
    </div>
  );
}
